<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="printTests"
    >
      <section slot="pdf-content" class="p-2 font-modify">
        <div class="header p-3">
          <h1 dir="rtl" class="font-modify">مختبر</h1>
          <h2 class="subheader-title">مستشفى الوزيرية الاهلي</h2>
          <h2 class="subheader-title">للتحليلات المرضية و الهرمونات</h2>
        </div>

        <div class="info-header">
          <div class="patient-info">
            <span
              >Name:
              <span class="arabic-text ml-2"
                >{{
                  data.patient_card.patient.gender === "Female"
                    ? "السيدة /"
                    : "السيد /"
                }}
                {{ data.patient_card.patient.name }}
              </span>
            </span>
            <br />
            <span
              >Sex / Age:
              <span class="arabic-text ml-2">
                {{ patientAge }} Years / {{ data.patient_card.patient.gender }}
              </span>
            </span>
            <br />
            <span
              >Referred By:
              <span class="arabic-text ml-2">{{
                data.patient_card.referred_by
              }}</span></span
            >
          </div>
          <div class="date-info">التاريخ: {{ getCurrentDate() }}</div>
        </div>
        <h2 class="text-center" style="text-decoration: underline">{{ data.test_report_name }}</h2>
        <div v-for="(test, index) in data.data" :key="index">
            <h4>{{ test.category }}:</h4>
        <table class="styled-table">
          <thead>
            <tr>
              <th>Test Name</th>
              <th>Result</th>
              <th>Reference Range</th>
              <!-- <th>Result - Normal</th> -->
            </tr>
          </thead>
          <tbody >
            <tr v-for="(test, index) in test.data" :key="index">
              <td>{{ test.name }}</td>
              <td>{{ test.value }}</td>
              <td>{{ test.reference_range }}</td>
              <!-- <td>{{ test.unit ? test.unit.name : "-" }}</td> -->
              <!-- <td>
                {{ test.min }} -
                {{ test.max }}
              </td> -->
              <!-- <td>{{ test.result_as_to_normal_range }}</td> -->
            </tr>
            </tbody>
          </table>
        </div>

        <div class="footer-info">
          <div>07705845953</div>
          <div class="location-info">
            <span>مجاور مستشفى الوزيرية الاهلي - </span>
            <span>مقابل كلية التربية الرياضية للبنات - </span>
            <span>الوزيرية</span>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      testData: this.data,
    };
  },
  props: ["data"],
  mounted() {},
  computed: {
    patientAge() {
      if (!this.data.patient_card.patient.birth_date) return null;
      const birthDate = new Date(this.data.patient_card.patient.birth_date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
  },

  methods: {
    modifyData() {
      this.testData.data = JSON.parse(this.data.data);
      console.log(this.testData.data);
    },
    generateReport() {
    //   this.modifyData();
      this.$refs.printTests.generatePdf();
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}/${month}/${day}`;
    },
  },
};
</script>

<style scoped>
.arabic-text {
  direction: rtl;
  unicode-bidi: bidi-override;
  font-family: "Scheherazade", Arial, sans-serif; /* Use a font that supports Arabic */
  direction: rtl; /* Set right-to-left direction */
}
.font-modify {
  letter-spacing: normal !important;
}
/* General Styling for PDF */
.pdf-content {
  font-family: Arial, sans-serif;
}
.header {
  text-align: center;
  margin-bottom: 20px;
}
.header-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 5px;
}
.subheader-title {
  font-size: 24px;
  font-weight: 600;
}
.info-header {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  margin-bottom: 20px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  margin-bottom: 20px;
}
.styled-table th,
.styled-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}
.styled-table th {
  background-color: #f3f3f3;
  font-weight: bold;
}
.footer-info {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.location-info {
  display: flex;
  gap: 8px;
}
</style>
